import GenericModel from '../generic-model';
import { SubProject } from '../project/sub-project';
import { Tour } from './tour';
import { ImmoTask } from '../immo-task/immo-task';
import LoggedAction from '../logged-action';

export class TourItem extends GenericModel {
  sequenceNumber?: number;

  locked?: boolean;

  subProject?: SubProject;

  immoTask?: ImmoTask;

  tour?: Tour;

  tourRegistration?: LoggedAction;

  // front end variables
  tourItemBackgroundClass?: string;
  tourItemExecutionClass?: string;
}
